import { ReactElement } from "react"; 

export default function ComponentSwitcher({ active, children } : {active: string, children: ReactElement[]}) : ReactElement {
    return children.filter((child: ReactElement) => child.props.name === active)[0];
}
